import i18n from '@/i18n'

export default [
  {
    path: '/users',
    component: () => import(/* webpackChunkName: "Users" */ '@/views/Users/Users.vue'),
    props: (route) => ({ ...route.params }),
    meta: {
      noContextRequired: true,
      permissions: ['Mapi.Users.Read'],
      menu: {
        index: 70,
        routeName: 'userOverview',
        activeWhen: ['userOverview', 'userDetail'],
        title: i18n.t('label.users'),
        icon: ['fal', 'user-friends']
      }
    },
    children: [
      {
        path: '',
        name: 'userOverview',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/Users/Overview/UsersOverview.vue'),
        meta: {
          permissions: ['Mapi.Users.Read']
        }
      },
      {
        path: 'add',
        name: 'addUser',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/Users/Detail/UserDetail.vue'),
        props: (route) => ({ userId: null }),
        meta: {
          permissions: ['Mapi.Users.Read', 'Mapi.Users.Create']
        }
      },
      {
        path: ':userId',
        name: 'userDetail',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/Users/Detail/UserDetail.vue'),
        meta: {
          permissions: ['Mapi.Users.Read']
        },
        props: true
      }
    ]
  }
]
